import { render } from "./AddQuestionAdmin.vue?vue&type=template&id=1672d29c&scoped=true"
import script from "./AddQuestionAdmin.vue?vue&type=script&lang=js"
export * from "./AddQuestionAdmin.vue?vue&type=script&lang=js"

import "./AddQuestionAdmin.vue?vue&type=style&index=0&id=1672d29c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1672d29c"]])

export default __exports__